import axios from 'axios';
import {FieldValues, Path, UseFormReturn} from 'react-hook-form';
import {BackendErrorResponse} from './backend-error-response';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';

export function onFormQueryError<T extends FieldValues>(
  r: unknown,
  form: UseFormReturn<T>,
) {
  if (form && axios.isAxiosError(r) && r.response) {
    const response = r.response.data as BackendErrorResponse;
    if (!response.errors) {
      showHttpErrorToast(r);
    } else {
      Object.entries(response.errors || {}).forEach(([key, errors], index) => {
        if (typeof errors === 'string') {
          form.setError(key as Path<T>, {message: errors}, {shouldFocus: index === 0});
        } else {
          errors.forEach((message, subIndex) => {
            form.setError(
              key as Path<T>,
              {message},
              {shouldFocus: index === 0 && subIndex === 0},
            );
          });
        }
      });
    }
  }
}
